import { jsxs, jsx } from 'react/jsx-runtime';
import { ChannelCard as p } from './contact-channels93.js';
import { ChatContent as j } from './contact-channels31.js';
import { ChatFooter as F } from './contact-channels32.js';
import { ChatHeader as G } from './contact-channels30.js';

function _extends(){_extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target};return _extends.apply(this,arguments)}const x=i=>{const{cardOverrides:t,containerOverrides:e,footerConfig:n,variation:r="minimal",onClick:a}=i;return jsxs(p,{cardOverrides:_extends({},t,{onClick:a}),containerOverrides:e,isMinimal:r==="minimal",children:[jsx(G,{variation:r}),jsx(j,{variation:r}),jsx(F,_extends({variation:r},n))]})};

export { x as Chat };
//# sourceMappingURL=contact-channels29.js.map
